import { Skeleton } from 'antd';

const Loading: React.FC = () => {
  if (window.location.pathname.includes('login')) {
    return null;
  }
  return <Skeleton style={{ margin: '24px 40px', height: '60vh' }} active />;
};

export default Loading;
